module.exports = __webpack_public_path__ + "static/media/tenderprism.f55415a6.jpg";